import { useEffect } from 'react'

export const SEO_TITLE = 'KeyTurn | Hotel Pre-Opening Project Intelligence'

export const SEO_DESCRIPTION =
  'KeyTurn is hotel project intelligence and pre-opening project management software that surfaces risk, automates admin and keeps every opening on track.'

export const SEO_URL = 'https://keyturn.online/'

/** Creates the tag on first run, then keeps it in step with the value. */
function upsertMeta(selectorAttribute: 'name' | 'property', key: string, content: string) {
  const selector = `meta[${selectorAttribute}="${key}"]`
  let tag = document.head.querySelector<HTMLMetaElement>(selector)

  if (!tag) {
    tag = document.createElement('meta')
    tag.setAttribute(selectorAttribute, key)
    document.head.appendChild(tag)
  }

  tag.setAttribute('content', content)
}

function upsertCanonical(href: string) {
  let link = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]')

  if (!link) {
    link = document.createElement('link')
    link.setAttribute('rel', 'canonical')
    document.head.appendChild(link)
  }

  link.setAttribute('href', href)
}

/**
 * Sets the document title, description, canonical URL and social metadata.
 * Existing og:image and twitter:image tags are deliberately left untouched.
 */
export function useSeoMetadata() {
  useEffect(() => {
    document.title = SEO_TITLE

    upsertMeta('name', 'description', SEO_DESCRIPTION)
    upsertCanonical(SEO_URL)

    upsertMeta('property', 'og:type', 'website')
    upsertMeta('property', 'og:site_name', 'KeyTurn')
    upsertMeta('property', 'og:title', SEO_TITLE)
    upsertMeta('property', 'og:description', SEO_DESCRIPTION)
    upsertMeta('property', 'og:url', SEO_URL)

    upsertMeta('name', 'twitter:card', 'summary_large_image')
    upsertMeta('name', 'twitter:title', SEO_TITLE)
    upsertMeta('name', 'twitter:description', SEO_DESCRIPTION)
  }, [])
}
